export default __webpack_public_path__ + "static/media/qr.c9feb19e.png";